import axios, { type InternalAxiosRequestConfig } from 'axios';

import { environment } from '../../../../enviroments';

export const api = axios.create({
  baseURL: environment.url_api_producao_service,
  withCredentials: false,
});

/** Remove Authorization quando config.skipAuth (ex: GetUrlCompleta/PostUrlCompleta) */
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const skipAuth = (
    config as InternalAxiosRequestConfig & { skipAuth?: boolean }
  ).skipAuth;

  if (skipAuth && config.headers && 'delete' in config.headers) {
    (config.headers as { delete: (name: string) => boolean }).delete(
      'Authorization'
    );
  }

  return config;
});

export const setAuthorizationToken = (token: string | null | undefined) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    api.defaults.headers.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
    delete api.defaults.headers.Authorization;
  }
};
